<template>
  <div>
    <basic-container>
      <avue-crud :option="option" :data="list" ref="crud" @refresh-change="refreshChange">
        <!-- 自定义搜索框 -->
        <template slot="mySearch">
          <div class="search-contain">
            <div class="search-left">
              <el-date-picker clearable style="width: 20% !important;margin-right: .625rem;"
                v-model="searchParams.addStartTime" type="daterange" range-separator=" " start-placeholder="申请时间"
                align="right" value-format="yyyy-MM-dd" unlink-panels :picker-options="{
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }"></el-date-picker>
              <el-date-picker clearable style="width: 20% !important;margin-right: .625rem;"
                v-model="searchParams.reviewStartTime" type="daterange" range-separator=" " start-placeholder="处理时间"
                align="right" value-format="yyyy-MM-dd" unlink-panels :picker-options="{
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }"></el-date-picker>
              <el-input size="medium" v-model="searchParams.orderSearch"
                style="width: 20% !important;margin-right: .625rem;" clearable placeholder="退款编号/订单编号"></el-input>
              <el-input size="medium" v-model="searchParams.userSearch"
                style="width: 20% !important;margin-right: .625rem;" clearable placeholder="用户账户"></el-input>
              <el-select size="medium" v-model="searchParams.payMethod"
                style="width: 20% !important;margin-right: .625rem;" clearable placeholder="支付方式">
                <!-- 支付方式：1微信 2支付宝 -->
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
              </el-select>
              <el-select size="medium" v-model="searchParams.refundStatus"
                style="width: 20% !important;margin-right: .625rem;" clearable placeholder="退款状态">
                <!-- 退款状态：1待处理 2退款中 3退款成功 4退款失败 5拒绝退款 -->
                <el-option label="待处理" value="1"></el-option>
                <el-option label="退款中" value="2"></el-option>
                <el-option label="退款成功" value="3"></el-option>
                <el-option label="退款失败" value="4"></el-option>
                <el-option label="拒绝退款" value="5"></el-option>

              </el-select>
              <el-button v-auth="'REFOUND_ORDER_SEARCH'" style="margin-right: 0.5%;" type="primary" size="small"
                @click="search">搜 索</el-button>
              <el-button v-auth="'REFOUND_ORDER_EXPORT'" style="position: relative;" type="primary" size="small"
                @click="exportAll">导 出</el-button>
              <!-- <el-button v-auth="'REFOUND_ORDER_EXPORT'" style="position: relative;" type="primary" size="small"
                @click="exportExcel">导 出</el-button> -->
            </div>
            <div class="search-left" style="margin-top: 10px;"></div>
          </div>
        </template>
        <!-- 自定义表格列 -->
        <template #mediaName="scope">
          <span style="color: blue;">{{ scope.row.mediaName }}</span>
        </template>
        <template #payee="scope">
          <span>{{ scope.row.vodPayOrder.payee }}</span>
        </template>
        <template #payMethod="scope">
          <!-- 	支付方式，1微信 2支付宝 -->
          <span v-if="scope.row.vodPayOrder.payMethod == 1">微信</span>
          <span v-else-if="scope.row.vodPayOrder.payMethod == 2">支付宝</span>
        </template>
        <template #username="scope">
          <span>{{ scope.row.vodPayOrder.username }}</span>
        </template>
        <template #payOrderNo="scope">
          <span>{{ scope.row.vodPayOrder.payOrderNo }}</span>
        </template>
        <!-- 自定义表格操作栏 -->
        <template #menu="{ row }">
          <el-button v-auth="'REFOUND_ORDER_DETAIL'" type="text" size="small" @click="handleDetail(row)">查看详情</el-button>
        </template>
      </avue-crud>
      <ElementPagination style="margin-bottom: 20px;" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </basic-container>
    <!-- //^ ^--------------申请退款的对话框-------------^ ^ -->
    <el-dialog title="退款处理" append-to-body :visible.sync="detailVisible" width="45%" @closed="handleRefundClose">
      <el-form label-position="left" label-width="120px" :rules="refoundRules" ref="refundForm">
        <div class="detail-dialog-contain">
          <el-form-item label="订单编号：">
            {{
              refoundData.vodPayOrder
              ? refoundData.vodPayOrder.payOrderNo
              : "无"
            }}
            <el-button type="text" size="small" @click="
            $router.push({
              path: `../mediaOrder/index`,
              query: { id: refoundData.vodPayOrder.payOrderNo }
            })
              " style="margin-left: 20px;">查看</el-button>
          </el-form-item>
          <el-form-item label="用户账户：">
            {{
              refoundData.vodPayOrder ? refoundData.vodPayOrder.username : "无"
            }}
          </el-form-item>
          <el-form-item label="订单创建时间：">
            {{ refoundData.addTime }}
          </el-form-item>
          <el-form-item label="申请人：">
            {{ refoundData.addUser }}
          </el-form-item>
          <el-form-item label="申请操作时间：">
            {{ refoundData.reviewTime }}
          </el-form-item>
        </div>
        <div class="detail-dialog-contain">
          <el-form-item label="媒资名称：">
            {{ refoundData.vodMedia ? refoundData.vodMedia.name : "无" }}
          </el-form-item>
          <el-form-item label="媒资ID：">
            {{
              refoundData.vodPayOrder ? refoundData.vodPayOrder.mediaId : "无"
            }}
          </el-form-item>
          <el-form-item label="媒资有效期：">
            {{
              refoundData.vodPayOrder
              ? refoundData.vodPayOrder.validStartTime
              : "无"
            }}
            至
            {{
              refoundData.vodPayOrder
              ? refoundData.vodPayOrder.validEndTime
              : "无"
            }}<span v-if="new Date(refoundData.vodPayOrder.validEndTime).getTime() <
    Date.now()
    " style="color: red;">（已失效）</span>
          </el-form-item>
        </div>
        <div class="detail-dialog-contain">
          <el-form-item label="退款单号：">
            {{ refoundData.refundOrderNo }}
          </el-form-item>
          <el-form-item label="订单金额：">
            {{ refoundData.vodPayOrder.payMoney }}元
          </el-form-item>
          <el-form-item label="退款金额：">
            {{ refoundData.refundMoney }}元
          </el-form-item>
          <el-form-item label="退款状态：">
            <!-- 退款状态：1待处理 2退款中 3退款成功 4退款失败 5拒绝退款 -->
            <span v-if="refoundData.refundStatus == 1">待处理</span>
            <span v-else-if="refoundData.refundStatus == 2">退款中</span>
            <span v-else-if="refoundData.refundStatus == 3">退款成功</span>
            <span v-else-if="refoundData.refundStatus == 4">退款失败</span>
            <span v-else-if="refoundData.refundStatus == 5">拒绝退款</span>

          </el-form-item>
          <el-form-item label="退款时间：">
            {{ refoundData.refundTime }}
          </el-form-item>
          <el-form-item label="退款方式：">
            {{
              refoundData.vodPayOrder
              ? refoundData.vodPayOrder.payMethod == 1
                ? "退还到原支付渠道(微信)"
                : "退还到原支付渠道(支付宝)"
              : "无"
            }}</el-form-item>
          <el-form-item label="退款原因：">
            {{ refoundData.refundReason }}
          </el-form-item>
          <el-form-item label="处理备注：">
            <el-input v-model="reviewDescr" style="width: 60%;margin-bottom: 20px;" type="textarea"
              :autosize="{ minRows: 2, maxRows: 10000 }" maxlength="9999" show-word-limit></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="!(refoundData.refundStatus === 1)" type="primary" @click="handleRefund(1)">确认退款
        </el-button>
        <!-- 拒绝退款 -->
        <el-button :disabled="!(refoundData.refundStatus === 1)" type="danger" @click="handleRefund(0)">拒绝退款
        </el-button>
        <el-button @click="handleRefundClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import options from "./option";
import moment from "moment";
import {
  getList,
  getDetail,
  confirmRefund,
  exportRefundOrder
} from "@/api/mediaManage/refoundOrder.js";
export default {
  name: "WebOpenPlatformIndex",
  components: {
    ElementPagination
  },
  data() {
    return {
      // ^ ^--------------申请退款对话框内的数据-------------^ ^
      /** 处理备注 */
      reviewDescr: "",
      /** 申请对话框内的数据 */
      refoundData: {
        vodPayOrder: {
          validEndTime: ""
        }
      },
      /** 申请退款的表单验证规则 */
      refoundRules: {
        refoundMoney: [
          {
            required: true,
            message: "请输入退款金额",
            trigger: "blur"
          }
        ],
        reason: [
          {
            required: true,
            message: "请输入退款原因",
            trigger: "blur"
          }
        ]
      },
      /** 申请退款对话框的显隐 */
      detailVisible: false,
      id: 1,
      option: options(this),
      /** 搜索参数的配置 */
      searchParams: {
        current: 1,
        size: 10,
        total: 50,
        /** 申请时间 默认最近七天*/
        addStartTime: this.calculateRecentSevenDays(),
        /** 处理时间 */
        reviewStartTime: this.calculateRecentSevenDays(),
        /** 退款编号 */
        orderSearch: "",
        /** 用户账户 */
        userSearch: "",
        /** 支付方式 */
        payMethod: "",
        /** 退款状态 */
        refundStatus: ""
      },

      /** 表格里的数据 */
      list: []
    };
  },

  created() {
    this.loadList();
  },

  methods: {
    calculateRecentSevenDays() {
      const today = moment();
      const sevenDaysAgo = moment().subtract(6, "days");

      const startDate = sevenDaysAgo.format("YYYY-MM-DD");
      const endDate = today.format("YYYY-MM-DD");

      return [startDate, endDate];
    },
    /** 全部导出 */
    async exportAll() {

      const params = { ...this.searchParams }
      /** 删除分页相关的属性 */
      delete params.current
      delete params.size
      delete params.total
      /** 调用接口 */
      const res = await exportRefundOrder(params);
      console.log("全部导出的响应", res);
      /** 导出excel */
      const { data, headers } = res

      const blob = new Blob([data], { type: headers['content-type'] })
      const dom = document.createElement('a')
      const downUrl = window.URL.createObjectURL(blob)
      dom.href = downUrl
      dom.download = decodeURIComponent('退款订单_' + moment().format('YYYY-MM-DD HH:mm:ss') + '.xlsx')
      dom.style.display = 'none'
      document.body.appendChild(dom)
      dom.click()
      dom.parentNode.removeChild(dom)
      window.URL.revokeObjectURL(downUrl)

    },
    /** 导出的事件 */
    exportExcel() {
      /** 按类名获取html按钮元素 */
      const btn = document.getElementsByClassName(
        "el-button el-button--primary el-button--small"
      );
      console.log("导出的事件", btn);
      /** 触发这个元素的点击事件 */
      btn[3].click();
    },
    /** 关闭确认申请对话框的事件 */
    handleRefundClose() {
      this.detailVisible = false;
      this.reviewDescr = "";
    },
    /** 确认退款的事件 */
    async handleRefund(reviewStatus) {
      // 0拒绝退款 1同意退款
      console.log("确认退款的事件");
      const params = {
        id: String(this.refoundData.id),
        reviewDescr: this.reviewDescr,
        reviewStatus: String(reviewStatus)
      };
      console.log("确认退款的参数", params);
      const res = await confirmRefund(params);
      console.log("退款操作的响应", res);
      if (res.data.code == 200) {
        Message.success("操作成功");
        this.handleRefundClose()
        this.loadList();
      }
    },
    /** //^ ^--------------表格操作栏的事件-------------^ ^ */
    /** 申请退款的事件 */
    async handleDetail(row) {
      console.log("申请退款的事件", row);
      /** 获取明细 */
      const { data } = await getDetail(row.id);
      console.log("获取明细的响应", data);
      this.refoundData = data.data;
      this.detailVisible = true;
    },
    /** avue刷新控件的方法 */
    async refreshChange() {
      console.log("refreshChange");
      /** 更新数据 */
      await this.loadList();
      /** 提示用户 */
      Message.success("刷新成功");
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索事件 */
    async search() {
      console.log("搜索事件", this.searchParams);
      /** 处理时间格式 */
      this.searchParams.addStartDate = this.searchParams.addStartTime
        ? this.searchParams.addStartTime[0]
        : null;
      this.searchParams.addEndDate = this.searchParams.addStartTime
        ? this.searchParams.addStartTime[1]
        : null;
      this.searchParams.reviewStartDate = this.searchParams.reviewStartTime
        ? this.searchParams.reviewStartTime[0]
        : null;
      this.searchParams.reviewEndDate = this.searchParams.reviewStartTime
        ? this.searchParams.reviewStartTime[1]
        : null;
      /** 更新数据 */
      this.searchParams.current = 1
      await this.loadList();
      /** 提示用户 */
      Message.success("搜索成功");
    },
    /** 获取列表数据 */
    async loadList() {
      const { data } = await getList(this.searchParams);
      console.log("分页查询数据的响应", data);
      this.searchParams.total = data.data.total;
      this.list = data.data.records;
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button[disabled] {
  background-color: #ebeef5 !important;
  color: #c0c4cc !important;
  border-color: #d3dce6 !important;
}

.search-left {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

// ^ ^--------------预设的样式-------------^ ^
.flex {
  margin-top: 10px;
  padding: 2% 15%;
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap !important;
  background-color: #f7f7f7;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}

.detail-dialog-contain {
  background-color: #f7f7f7;
  padding: 0 10%;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__menu {
  position: relative;
  overflow: visible;

  .avue-crud__left {
    position: relative;

    .el-button {
      display: none;
      position: absolute;
      top: -4.5vw;
      left: 72vw;

      span {
        margin: 0;
      }

      .el-icon-download {
        display: none;
      }
    }
  }
}

::v-deep .el-card .is-never-shadow {
  overflow: visible !important;
}
</style>
